import {create} from 'zustand';
import {ModalDiscardChangesStateStore} from './types';

export const useModalDiscardChangesState = create<ModalDiscardChangesStateStore>(set => ({
	state: false,
	setState: state => set({state}),
}));
